import { EX_SPOUSE_WIDTH } from '../utils/elkLayout.constants';
import { PersonData, PersonTile } from './PersonTile';

interface SpousePersonTileProps {
  id: string;
  person: PersonData;
}

export function SpousePersonTile({ id, person }: SpousePersonTileProps) {
  return (
    <PersonTile
      id={id}
      data={{
        person: {
          ...person,
          id: `${id}`,
        },
      }}
      selectable={true}
      selected={false}
      dragging={false}
      type="person"
      zIndex={1}
      deletable={false}
      draggable={false}
      isConnectable={false}
      positionAbsoluteX={0}
      positionAbsoluteY={0}
      width={EX_SPOUSE_WIDTH}
    />
  );
}
